import { AllowedDetailsTabEnum } from '@core/interfaces/common.interfaces';
import {
	IRouteBaseDefinition,
	RouteBasePathEnum
}                                from '@core/interfaces/route.interface';


export enum AdminConsoleRoutesEnum {
	ArchiveOffboardingCreateFormPage = 'archive-offboarding/create',
	ArchiveOffboardingDetailPage = 'archive-offboarding/:archiveOffboardingId',
	ArchiveOffboardingDetailPageTab = 'archive-offboarding/:archiveOffboardingId/:tab',
	ArchiveOffboardingListPage = 'archive-offboarding',
	FccVersionCreateFormPage = 'fcc-versions/create',
	FccVersionListPage = 'fcc-versions',
	FccVersionUpdateFormPage = 'fcc-versions/:fccVersionId/update',
	GlobalStatisticsPage = 'global-statistics',
	UsageDtrPage = 'usage-dtr',
	UsageDtrPageTabVolumeModelTab = 'usage-dtr/volume/:usagePeriod',
	UsageGkPage = 'usage-gk',
	UsageGkPageTabUsageModelTab = 'usage-gk/usage/:usagePeriod',
	UserDetailPage = 'users/:userId',
	UserListPage = 'users'
}


interface AdminConsoleBaseRoute extends IRouteBaseDefinition {
	basePath: RouteBasePathEnum.AdminConsole;
	path: AdminConsoleRoutesEnum;
	params?: { [ key: string ]: string };
}


// Archive Offboarding
export interface AdminConsoleArchiveOffboardingDetailPageRoute extends AdminConsoleBaseRoute {
	path: AdminConsoleRoutesEnum.ArchiveOffboardingDetailPage;
	params: { archiveOffboardingId: string };
}

export interface AdminConsoleArchiveOffboardingDetailPageTabRoute extends AdminConsoleBaseRoute {
	path: AdminConsoleRoutesEnum.ArchiveOffboardingDetailPageTab;
	params: { archiveOffboardingId: string, tab: AllowedDetailsTabEnum };
	replaceLastStoredRouteWithNew: boolean;
}

export interface AdminConsoleArchiveOffboardingFormPageCreateRoute extends AdminConsoleBaseRoute {
	path: AdminConsoleRoutesEnum.ArchiveOffboardingCreateFormPage;
}

export interface AdminConsoleArchiveOffboardingListPageRoute extends AdminConsoleBaseRoute {
	path: AdminConsoleRoutesEnum.ArchiveOffboardingListPage;
}


// DTR Usage
export interface AdminConsoleUsageDtrPageRoute extends AdminConsoleBaseRoute {
	path: AdminConsoleRoutesEnum.UsageDtrPage;
}

export interface AdminConsoleUsageDtrPageTabVolumeModelTabRoute extends AdminConsoleBaseRoute {
	path: AdminConsoleRoutesEnum.UsageDtrPageTabVolumeModelTab;
	params: {
		usagePeriod: string
	};
}


// FCC Version
export interface AdminConsoleFccVersionCreateFormPageRoute extends AdminConsoleBaseRoute {
	path: AdminConsoleRoutesEnum.FccVersionCreateFormPage;
}

export interface AdminConsoleFccVersionListPageRoute extends AdminConsoleBaseRoute {
	path: AdminConsoleRoutesEnum.FccVersionListPage;
}

export interface AdminConsoleFccVersionUpdateFormPageRoute extends AdminConsoleBaseRoute {
	path: AdminConsoleRoutesEnum.FccVersionUpdateFormPage;
	params: { fccVersionId: string };
}


// GK Usage
export interface AdminConsoleUsageGkPageRoute extends AdminConsoleBaseRoute {
	path: AdminConsoleRoutesEnum.UsageGkPage;
}

export interface AdminConsoleUsageGkPageTabUsageModelTabRoute extends AdminConsoleBaseRoute {
	path: AdminConsoleRoutesEnum.UsageGkPageTabUsageModelTab;
	params: {
		usagePeriod: string
	};
}


// Global Statistics
export interface AdminConsoleStatisticsPageRoute extends AdminConsoleBaseRoute {
	path: AdminConsoleRoutesEnum.GlobalStatisticsPage;
}


// Operators (Users)
export interface AdminConsoleUserDetailPageRoute extends AdminConsoleBaseRoute {
	path: AdminConsoleRoutesEnum.UserDetailPage;
	params: {
		userId: string
	};
}

export interface AdminConsoleUserListPageRoute extends AdminConsoleBaseRoute {
	path: AdminConsoleRoutesEnum.UserListPage;
}
